<template>
  <section class="p-box">
    <header class="p-box__header">
      <h3 class="p-box__title">
        {{ $t('pages.CompaniesLocationStore.mediaLibraries.title') }}
      </h3>
    </header>
    <div class="p-box__body">
      <Loading v-if="loading" />
      <span v-else-if="!isEnabled">{{ $t('messages.setupGmbOrYahoo') }}</span>
      <template v-else>
        <div class="photos">
          <div
            v-for="(mediaLibrary, i) in firstFourMediaLibraries"
            :key="`mediaLibrary_${i}`"
            class="photos__item"
          >
            <div class="p-photos__image">
              <div :style="{ 'background-image': `url(${ mediaLibrary.mediaImageUrl })` }" />
            </div>
          </div>
          <div v-if="isEditable" class="photos__item">
            <router-link :to="{ name: 'CompaniesLocationStoreMediaLibraryUpload', params: { company_uuid: companyUuid, store__uuid: storeUuid }}">
              <div class="photoAdd">
                <div class="photoAdd__content">
                  <span class="photoAdd__label">
                    <Icon name="iconPlus" class="photoAdd__icon" />
                    {{ $t('pages.CompaniesLocationStore.mediaLibraries.addImage') }}
                  </span>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="c-button c-button--right">
          <div>
            {{ $t('pages.CompaniesLocationStore.mediaLibraries.allImageCount', { count: totalCount }) }}
          </div>
          <div v-if="mediaLibraries.length > 0">
            <router-link :to="{ name: 'CompaniesLocationStoreMediaLibraries', params: { company_uuid: companyUuid, store__uuid: storeUuid }}" class="c-button__item c-button__item--primary">
              {{ $t('pages.CompaniesLocationStore.mediaLibraries.linkToImageLibrary') }}
            </router-link>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
import Icon from '../Icon'
import Loading from '../Loading'

export default {
  name: 'CompaniesLocationStoreMediaLibraries',
  components: {
    Loading,
    Icon
  },
  props: {
    mediaLibraries: {
      type: Array,
      required: true
    },
    totalCount: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    isEnabled: {
      type: Boolean,
      required: true
    },
    isEditable: {
      type: Boolean,
      required: true
    },
  },
  computed: {
    companyUuid() {
      return this.$route.params.company_uuid
    },
    storeUuid() {
      return this.$route.params.store_uuid
    },
    firstFourMediaLibraries() {
      return this.mediaLibraries.slice(0, 4)
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/biz_spa/foundation/_var.scss";
@import "../../../../stylesheets/biz_spa/foundation/_mixin.scss";
.photos {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -12px;
  &__item {
    width: 100%;
    padding: 12px;
  }
  @include mq(xs) {
    &__item {
      width: calc(100% / 3);
    }
  }
  @include mq(md) {
    &__item {
      width: calc(100% / 5);
    }
  }
}
.photoAdd {
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 100%;
  background: $color-base-i;
  text-align: center;
  &__content {
    margin: auto;
  }
  &__label {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 100%;
    color: $color-accent-primary;
    font-size: 16px;
    text-align: center;
  }
  &__icon {
    width: 16px;
    height: 16px;
  }
}
</style>
